import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./RegistrationForm.css";
import logo from "../asset/logo.jpg";
import axios from "axios";
import Swal from "sweetalert2";

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.string()
    .matches(/\d{10}/, "Enter a valid 10-digit mobile number")
    .required("Mobile number is required"),
  userType: Yup.string().required("Please select an option"),
  college: Yup.string().when("userType", {
    is: "student",
    then: (schema) => schema.required("College name is required"),
  }),
  degree: Yup.string().required("Degree & Year of Passing is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  programmingKnowledge: Yup.string(),
  interestReason: Yup.string(),
  transactionId: Yup.string().required("Transaction ID is required"),
});

const Header = () => (
  <header className="header">
    <img src={logo} alt="CodeBonding Logo" className="logo" />
  </header>
);

const Footer = () => (
  <footer className="footer">&copy; 2025 CodeBonding. All Rights Reserved.</footer>
);

const RegistrationForm = () => {
  const initialValues = {
    fullName: "",
    email: "",
    mobile: "",
    userType: "",
    college: "",
    degree: "",
    city: "",
    state: "",
    programmingKnowledge: "",
    interestReason: "",
    transactionId: "",
  };

  const onSubmit = async (values, { setSubmitting, resetForm, setErrors }) => {
    try {
        const response = await axios.post(
            "https://1568d777p0.execute-api.ap-northeast-1.amazonaws.com/api/students/register",
            values
        );

        Swal.fire({
            icon: "success",
            title: "Registration Successful!",
            text: "Thank you for registering.",
            confirmButtonColor: "#015D6C",
        });

        resetForm();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
            const errorMessages = error.response.data.errors;
            
            const formikErrors = {};
            errorMessages.forEach(err => {
                formikErrors[err.field] = err.message;
            });

            setErrors(formikErrors);

            Swal.fire({
                icon: "error",
                title: "Registration Failed",
                html: errorMessages.map(err => `<p>${err.message}</p>`).join(""),
                confirmButtonColor: "#015D6C",
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Registration Failed",
                text: "An unexpected error occurred. Please try again.",
                confirmButtonColor: "#015D6C",
            });
        }
    }
    setSubmitting(false);
};

  return (
    <div>
      <Header />
      <div className="form-container">
        <h2 className="form-title">Register Now</h2>
        <p className="payment-details">Payment Details: UPI ID - <strong>codebonding@ybl</strong></p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <label>Full Name</label>
              <Field name="fullName" className="input-field" />
              <ErrorMessage name="fullName" component="p" className="error-text" />

              <label>Email</label>
              <Field name="email" className="input-field" />
              <ErrorMessage name="email" component="p" className="error-text" />

              <label>Mobile Number</label>
              <Field name="mobile" className="input-field" />
              <ErrorMessage name="mobile" component="p" className="error-text" />

              <label>Are you a Student or Graduate?</label>
              <Field as="select" name="userType" className="input-field">
                <option value="">Select</option>
                <option value="student">Student</option>
                <option value="graduate">Graduate</option>
              </Field>
              <ErrorMessage name="userType" component="p" className="error-text" />

              {values.userType === "student" && (
                <>
                  <label>College Name</label>
                  <Field name="college" className="input-field" />
                  <ErrorMessage name="college" component="p" className="error-text" />
                </>
              )}

              <label>Degree & Year of Passing</label>
              <Field name="degree" className="input-field" />
              <ErrorMessage name="degree" component="p" className="error-text" />

              <label>City</label>
              <Field name="city" className="input-field" />
              <ErrorMessage name="city" component="p" className="error-text" />

              <label>State</label>
              <Field name="state" className="input-field" />
              <ErrorMessage name="state" component="p" className="error-text" />

              <label>Programming Knowledge (Optional)</label>
              <Field name="programmingKnowledge" className="input-field" />

              <label>Why are you interested in this training? (Optional)</label>
              <Field name="interestReason" className="input-field" />

              <label>Transaction ID</label>
              <Field name="transactionId" className="input-field" />
              <ErrorMessage name="transactionId" component="p" className="error-text" />

              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Register Now"}
              </button>
            </Form>
          )}
        </Formik>
        <p className="contact-details">In case of any doubt, contact us: <strong>+91 9488220722</strong></p>
      </div>
      <Footer />
    </div>
  );
};

export default RegistrationForm;
